import React from 'react';

const status = (props) => {
    if (!props.statusMsg || props.statusMsg === '') {
        return null;
    }
    return (
        <div className="alert alert-success alert-info alert-white rounded mT5">
            <div className="icon"><i className="fa fa-info-circle"></i></div>
            <span>{props.statusMsg}</span>
        </div>
    )
};

export default status;